import { extendTheme, type ThemeConfig } from "@chakra-ui/react"

const config: ThemeConfig = {
  initialColorMode: "light",
  useSystemColorMode: true,
}

const theme = extendTheme({
  config,
  semanticTokens: {
    colors: {
      "bg.table": {
        default: "ui.light",
        _dark: "ui.darkSlate",
      },
      "bg.input": {
        default: "white",
        _dark: "gray.700",
      },
      "border.table": {
        default: "gray.200",
        _dark: "gray.600",
      },
      "text.input": {
        default: "black",
        _dark: "white",
      },
      "main.accent": {
        default: "ui.main",
        _dark: "#A3E635",
      },
      "text.dashboardTitle": {
        default: "ui.main",
        _dark: "#A3E635",
      },
    },
  },
  colors: {
    ui: {
      main: "#145705",
      secondary: "#EDF2F7",
      success: "#48BB78",
      danger: "#E53E3E",
      light: "#FAFAFA",
      dark: "#1A202C",
      darkSlate: "#252D3D",
      dim: "#A0AEC0",
    },
  },
  components: {
    Button: {
      variants: {
        primary: {
          bg: "main.accent",
          color: "ui.light",
          _hover: {
            bg: "#762B00",
          },
          _disabled: {
            bg: "main.accent",
            _hover: {
              bg: "main.accent",
            },
          },
        },
        danger: {
          bg: "ui.danger",
          color: "ui.light",
          _hover: {
            bg: "#E32727",
          },
        },
      },
    },
    Tabs: {
      variants: {
        enclosed: {
          tab: {
            _selected: {
              color: "main.accent",
            },
          },
        },
      },
    },
  },
})
export default theme
